var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.17 16.5h1.667v1.666h10V4.833h-10v1.666H4.17V4a.833.833 0 0 1 .833-.833H16.67a.833.833 0 0 1 .833.833v15a.833.833 0 0 1-.833.834H5.003a.833.833 0 0 1-.833-.834zm1.667-5.834h5.833v1.667H5.837v2.5L1.67 11.499l4.167-3.333z"
})));
export { SvgLogoutIcon as ReactComponent };
export default __webpack_public_path__ + "920198faede4415f08d4a2c2914de103.svg";